import type {
  StudentActivitiesFilters,
  StudentActivitiesDto,
  StudentActivitiesQuantity,
} from '~/types/student-activities'
import { ApiService, toData } from '~/shared/api'
import type { ApiDataResponse } from '~/shared/types/api'
import type { AxiosResponse } from 'axios'

export class StudentActivitiesService extends ApiService {
  readonly urls = {
    studentActivitiesQuantity: '/api/v1/yavagro/digitalprofiles/quantity',
    studentActivitiesFilterFields: '/api/v1/yavagro/digitalprofiles/filters',
    sendFormStudentActivities: '/api/v1/yavagro/employers-requests/add',
  }

  public getStudentActivitiesQuantity(
    query: Record<string, unknown>
  ): Promise<StudentActivitiesQuantity> {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
      if (value) params.append(key, String(value))
    })

    return this.http
      .request<ApiDataResponse<StudentActivitiesQuantity>>({
        url: `${this.urls.studentActivitiesQuantity}?${params}`,
      })
      .then(toData())
  }

  public getStudentActivitiesFilterFields(
    query: Record<string, unknown>
  ): Promise<StudentActivitiesFilters[]> {
    const params = new URLSearchParams()
    Object.entries(query).forEach(([key, value]) => {
      if (value) params.append(key, String(value))
    })

    return this.http
      .request<ApiDataResponse<StudentActivitiesFilters[]>>({
        url: `${this.urls.studentActivitiesFilterFields}?${params}`,
      })
      .then(toData())
  }

  sendForm(dto: StudentActivitiesDto): Promise<AxiosResponse> {
    return this.http.request({
      data: dto,
      method: 'POST',
      url: this.urls.sendFormStudentActivities,
      silent: true,
    })
  }
}
